var map = {
	"./_404.png": 7607,
	"./birthday_cake.png": 514,
	"./crown.png": 9337,
	"./dart.png": 789,
	"./dashing_away.png": 1763,
	"./exploding_head.png": 3549,
	"./fire.png": 9734,
	"./grinning_face.png": 120,
	"./hot_face.png": 6057,
	"./movember2024.png": 7685,
	"./muscle.png": 3827,
	"./partying_face.png": 8868,
	"./peace_symbol.png": 4883,
	"./person_biking.png": 3232,
	"./pink_ribbon.png": 7191,
	"./punch.png": 5812,
	"./rainbow_flag.png": 8365,
	"./red_heart.png": 8300,
	"./rocket.png": 5946,
	"./rofl.png": 8177,
	"./save_the_children.png": 4015,
	"./sign_of_the_horns.png": 3562,
	"./sos_button.png": 1182,
	"./star_struck.png": 3695,
	"./superhero.png": 3393,
	"./sweat_drops.png": 9387,
	"./tada.png": 6002,
	"./thumbsup.png": 7530,
	"./train_for_brains.png": 4648,
	"./train_for_schools.png": 408,
	"./train_for_water.png": 1282,
	"./trophy.png": 5004,
	"./waving_hand.png": 6858,
	"./zany_face.png": 6820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8001;